import { paletteOperation, paletteSpecies } from '../charts/palette';
import type { FmStoryMapLegendCategory, FmStoryMapLegendFeature } from './elementMedia.types';

/** The swatch each registered map renderer paints its furniture in. */
const MAP_FEATURE_SWATCH: Readonly<Record<FmStoryMapLegendFeature, string>> = {
  'property-boundary': 'var(--fm-d-fg-2)',
  'access-route': 'var(--fm-amber)',
  thinning: paletteOperation('thinning'),
  'seed-tree': paletteOperation('seed-tree'),
  clearcut: paletteOperation('clearcut'),
  planting: paletteOperation('planting'),
  tending: paletteOperation('tending'),
  untouched: paletteOperation('untouched'),
};

/** A species entry is coloured by its code, exactly as the charts colour it. */
export function mapLegendCategorySwatch(entry: FmStoryMapLegendCategory): string {
  return entry.speciesCode !== undefined
    ? paletteSpecies(entry.speciesCode)
    : MAP_FEATURE_SWATCH[entry.feature];
}
